import service from './axios'

export const getBridgeWorkoutSets = ({
  personId,
  startDate,
  endDate,
  skip = 0,
  limit = 50
}) => {
  let query = `/bridge/workoutsets?personId=${personId}&skip=${skip}&limit=${limit}`
  if (startDate) query += `&startDate=${startDate}`
  if (endDate) query += `&endDate=${endDate}`
  return service.get(query)
}

export const getBridgeFormResults = ({
  personId,
  startDate,
  endDate,
  skip = 0,
  limit = 50
}) => {
  let query = `/bridge/formresults?skip=${skip}&limit=${limit}`
  if (personId) query += `&personId=${personId}`
  if (startDate) query += `&startDate=${startDate}`
  if (endDate) query += `&endDate=${endDate}`
  return service.get(query)
}
